import polyglotI18nProvider from 'ra-i18n-polyglot';
import en from './i18n/en';
import de from './i18n/de';


const translations = { en, de };

export const i18nProvider = polyglotI18nProvider(
  (locale) => translations['de'], 
  'de'
);